"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emToPx = (value, base) => Number.parseFloat(value) * base;
exports.default = emToPx;
